"use client";

import NotificationItem, {
  NotificationAvatar,
  NotificationWorkspaceLink,
} from "@/components/tailwind/notification/notificationItem";

interface NotificationRequestAcceptedProps {
  createdByName: string;
  createdById?: string;
  createdByEmail?: string;
  workspaceName: string;
  workspaceId?: string;
  createdAt: string;
  read?: boolean;
}

export default function NotificationRequestAccepted({
  createdByName,
  createdById,
  createdByEmail,
  workspaceName,
  workspaceId,
  createdAt,
  read,
}: NotificationRequestAcceptedProps) {
  return (
    <NotificationItem
      icon={<NotificationAvatar name={createdByName} userId={createdById} email={createdByEmail} />}
      createdAt={createdAt}
      unread={!read}
      title={createdByName}
      message={
        <>
          Accepted your request to join{" "}
          <NotificationWorkspaceLink workspaceId={workspaceId} workspaceName={workspaceName} />
        </>
      }
    />
  );
}
